var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.data,"loading":_vm.loading,"item-key":"name"},scopedSlots:_vm._u([{key:`item.date`,fn:function({ item }){return [_c('span',[_vm._v(_vm._s(_vm._f("formatToHuman")(item.date)))])]}}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }